import { PageController } from '@client/components/_core/layout/PageController';
import { createFileRoute } from '@tanstack/react-router';
import { Package } from 'lucide-react';
import { AsicProducts } from './AsicProducts';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/general/asic-products')({
    staticData: {
        metadata: {
            title: 'ASIC products',
        },
        ui: {
            icon: Package,
            title: 'ASIC products',
            subtitle: 'Product visibility shared across complaint and incident forms',
            menuDescription: 'Product visibility shared across complaint and incident forms',
        },
    },
    component: AsicProductsTab,
});

function AsicProductsTab() {
    return (
        <PageController route={Route}>
            <AsicProducts />
        </PageController>
    );
}
